import SimplicityProvider, { SimplicityDataProvider, SimplicityProviderOptions } from "@trustpilot/simplicity-provider";
import React, { useEffect } from "react";

import { postComplianceUser } from "../../api";
import { SIMPLICITY_DATA_SENT } from "../../constants";
import { logToSentry } from "../../utils/helpers";

export const Simplicity = () => {
  const simplicityProvider: SimplicityDataProvider = React.useMemo(() => {
    const simplicityOptions: SimplicityProviderOptions = {
      lazyInitialize: false,
      useFingerprint: true,
    };

    return new SimplicityProvider().withOptions(simplicityOptions).build();
  }, []);

  const initCallback = React.useCallback((simplicityData) => {
    const simplicityDataAlreadySent = sessionStorage.getItem(SIMPLICITY_DATA_SENT);

    // read cookies with 3 sec delay after load to make sure accessToken was properly updated in cookies after login
    // this should reduce amount of 401s
    window.setTimeout(() => {
      if (!simplicityDataAlreadySent) {
        // avoid calling endpoint on every page refresh,
        // should be called only once per user session
        postComplianceUser(simplicityData)
          .then(() => {
            sessionStorage.setItem(SIMPLICITY_DATA_SENT, "true");
          })
          .catch(logToSentry);
      }
    }, 3000);
  }, []);

  useEffect(() => {
    // Call Simplicity provider and allow up to 10 seconds for it to complete.
    simplicityProvider
      .getSimplicityData(10000)
      .then((simplicityData) => {
        initCallback(simplicityData);
      })
      .catch(logToSentry);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <React.Fragment />;
};
